const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/SublimdPage/SublimdPage.tsx';
import * as React from 'react';
import { css } from '@emotion/css';
import { useSublimdUrl } from 'App/store/sublimd';
import { PageNoCard } from '../PageNoCard';
import { RouteComponentProps } from 'react-router';

const iframeStyle = css`
    height: 100%;
    width: 100%;
    min-height: 750px;
`;

interface IRouteParams {
    termnr: string;
}

export const SublimdPage = (props: RouteComponentProps<IRouteParams>) => {
    const termnr = decodeURIComponent(props.match.params.termnr);

    const { data: url } = useSublimdUrl(termnr);
    if (!url) return null;

    return (
        <PageNoCard>
            <iframe
                sandbox="allow-same-origin allow-scripts"
                referrerPolicy={'no-referrer'}
                frameBorder={0}
                className={iframeStyle}
                src={url}
            />
        </PageNoCard>
    );
};
